import React, { useEffect, useMemo } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  DOWNLOAD_FALLBACK_URL
} from "config/appLinks";

// Detect the visitor's mobile platform from the User-Agent.
//
// iPad on iOS 13+ reports a desktop UA ("Macintosh") with platform "MacIntel",
// so we also treat a touch-capable MacIntel as iOS (the well-known workaround).
const detectPlatform = () => {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  const isIOS =
    /iphone|ipad|ipod/i.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isAndroid = /android/i.test(ua);
  if (isIOS) return "ios";
  if (isAndroid) return "android";
  return "unknown";
};

const pageStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f7f7f7",
  padding: "48px 16px"
};

const badgeImgStyle = {
  maxWidth: "100%",
  height: "auto",
  margin: "0 auto",
  display: "block"
};

function DownloadPage() {
  // Decide the redirect target during render (cheap, deterministic). Only
  // auto-redirect when the matching store link is configured — if the app
  // isn't published yet (link empty), we render the fallback page instead of
  // bouncing the visitor to a missing store page.
  const redirectTarget = useMemo(() => {
    const platform = detectPlatform();
    if (platform === "ios" && APP_STORE_URL) return APP_STORE_URL;
    if (platform === "android" && PLAY_STORE_URL) return PLAY_STORE_URL;
    return null;
  }, []);

  // Effect's only job is the side-effect on an external system (navigation).
  useEffect(() => {
    if (redirectTarget) window.location.replace(redirectTarget);
  }, [redirectTarget]);

  // Store link, or the marketing site when the app isn't published yet.
  const appStoreHref = APP_STORE_URL || DOWNLOAD_FALLBACK_URL;
  const playStoreHref = PLAY_STORE_URL || DOWNLOAD_FALLBACK_URL;

  if (redirectTarget) {
    return (
      <div style={pageStyle}>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: "#666", fontSize: 16 }}>
            Uygulamaya yönlendiriliyorsunuz…
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <Container className="text-center">
        <img
          alt="Flexplay"
          src={require("assets/img/flexplay_logo_bnw.png")}
          style={{ height: 56, marginBottom: 24, opacity: 0.9 }}
        />
        <h2 style={{ fontWeight: 700, color: "#222" }}>
          Flexplay&apos;i indirmek için
        </h2>
        <p style={{ color: "#666", marginTop: 8 }}>
          Cihazınıza uygun mağazadan ücretsiz indirin.
        </p>
        <Row
          className="store-container"
          style={{ justifyContent: "center", marginTop: 32 }}
        >
          <Col md="3" sm="4" xs="6" style={{ padding: 8 }}>
            <a href={appStoreHref} target="_blank" rel="noopener noreferrer">
              <img
                alt="Download on the App Store"
                className="img-rounded img-responsive"
                src={require("assets/img/app_store.png")}
                style={badgeImgStyle}
              />
            </a>
          </Col>
          <Col md="3" sm="4" xs="6" style={{ padding: 8 }}>
            <a href={playStoreHref} target="_blank" rel="noopener noreferrer">
              <img
                alt="Get it on Google Play"
                className="img-rounded img-responsive"
                src={require("assets/img/play_store.png")}
                style={badgeImgStyle}
              />
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DownloadPage;
